export const blockIconsActivitiesCampaignNew = (
	<span className='material-symbols-outlined'>campaign</span>
);
